import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  link: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    border-radius: var(--Radius-300);
    ${typo.heading05};
    font-weight: 500;
    color: var(--Colors-Gray-700);
    white-space: nowrap;

    &:hover {
      background: var(--Colors-Gray-100);
    }

    &:active {
      background: var(--Colors-Gray-200);
    }
  `,
  active: {
    color: 'var(--Colors-Sky-400)',
    cursor: 'default',
    fontWeight: 700,
  },
}

export default S
